import { useContext } from '@nuxtjs/composition-api';

import { getPdfServiceHost } from '@/shared/lib/utils/pdfServiceHost';

export function usePdfServiceHost (): string {
  const { $config } = useContext();

  return getPdfServiceHost($config.MAIN_SITE_HOST);
}
